import React, { Suspense, lazy } from 'react';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
// import AnnouncementBar from './components/AnnouncementBar';
import Header from './components/Header';
import Hero from './components/Hero';
import BrushSetDetails from './components/BrushSetDetails';
import OrderForm from './components/OrderForm';
import StickyATC from './components/StickyATC';
import Footer from './components/Footer';

const Reviews = lazy(() => import('./components/Reviews'));
const WhyBuyFromUs = lazy(() => import('./components/WhyBuyFromUs'));
const CashOnDeliverySection = lazy(() => import('./components/CashOnDeliverySection'));
const WhatsAppSection = lazy(() => import('./components/WhatsAppSection'));
const FAQ = lazy(() => import('./components/FAQ'));

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <CartProvider>
          <div className="text-[#2d1c2b] font-display min-h-screen flex flex-col selection:bg-primary selection:text-white transition-colors duration-300 bg-transparent">
            {/* <AnnouncementBar /> */}
            <Header />
            <main className="flex-grow flex flex-col relative overflow-hidden">
              {/* Hero with Product & Variant Selection */}
              <Hero />
              
              {/* Brush Set Details */}
              <BrushSetDetails />

              <Suspense fallback={null}>
                {/* Customer Reviews */}
                <Reviews />

                {/* Where to Use Section
                <UseCases /> */}
                
                {/* Why Buy From Us */}
                <WhyBuyFromUs />           
                
                {/* Cash on Delivery Callout */}
                <CashOnDeliverySection />
                
                {/* WhatsApp Contact */}
                <WhatsAppSection />
              </Suspense>

              {/* Embedded Order Form */}
              <OrderForm />

              <Suspense fallback={null}>
                {/* FAQ */}
                <FAQ />
              </Suspense>
            </main>
            <StickyATC />
            <Footer />
          </div>
        </CartProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
